export default {
    methods: {
        playSound(key) {
            this.$store.state.soundLib.play(key)
        }
    }
}



// WEBPACK FOOTER //
// ./src/delegate/soundDelegate.js